/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/zh_CN';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "访问精美 HTML 编辑器"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "辅助功能检查器"
  },
  "action_to_take_b626a99a": {
    "message": "要执行的操作："
  },
  "add_8523c19b": {
    "message": "添加"
  },
  "add_a_caption_2a915239": {
    "message": "添加说明"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "为图像添加替换文本"
  },
  "add_another_f4e50d57": {
    "message": "新增"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "添加抄送/副标题"
  },
  "add_image_60b2de07": {
    "message": "添加图像"
  },
  "add_one_9e34a6f8": {
    "message": "添加一个!"
  },
  "additional_considerations_f3801683": {
    "message": "其他考虑事项"
  },
  "address_applied_64269b0b": {
    "message": "已应用地址"
  },
  "address_removed_fcb496e0": {
    "message": "已移除地址"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "具有相同 URL 的相邻链接应该为一个单链接。"
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "协调"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "对齐和列表"
  },
  "all_4321c3a1": {
    "message": "全部"
  },
  "all_apps_a50dea49": {
    "message": "所有应用"
  },
  "allow_media_download_16dcf2bd": {
    "message": "允许下载媒体"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "允许下载文字记录"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "按字母顺序"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "替换属性文本不得超过 120 个字符。"
  },
  "alt_text_611fb322": {
    "message": "Alt 文本"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg（余积）"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "读取文件时发生错误"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "发出网络请求时出错"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "上传媒体时出错。"
  },
  "and_7fcc2911": {
    "message": "和"
  },
  "angle_c5b4ec50": {
    "message": "角度"
  },
  "announcement_fb4cb645": {
    "message": "公告"
  },
  "announcement_list_da155734": {
    "message": "公告列表"
  },
  "announcements_a4b8ed4a": {
    "message": "公告"
  },
  "apply_781a2546": {
    "message": "申请"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "将更改应用于课程中的该图标编辑器图标的所有实例"
  },
  "approaches_the_limit_893aeec9": {
    "message": "接近限值"
  },
  "approximately_e7965800": {
    "message": "大约"
  },
  "apps_54d24a47": {
    "message": "应用程序"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "确定要取消吗？您做出的变更可能无法保存。"
  },
  "arrows_464a3e54": {
    "message": "箭头"
  },
  "art_icon_8e1daad": {
    "message": "艺术图标"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "保留长宽比"
  },
  "assignment_976578a8": {
    "message": "作业"
  },
  "assignments_1e02582c": {
    "message": "作业"
  },
  "asterisk_82255584": {
    "message": "星号"
  },
  "attributes_963ba262": {
    "message": "属性"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "不支持音频和视频录制；请使用其他浏览器。"
  },
  "audio_options_feb58e2c": {
    "message": "音频选项"
  },
  "audio_options_tray_33a90711": {
    "message": "音频选项托盘"
  },
  "audio_player_for_title_20cc70d": {
    "message": "{ title }的音频播放器"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "存在自动保存的内容。是否要改为加载自动保存的内容？"
  },
  "available_folders_694d0436": {
    "message": "可用文件夹"
  },
  "background_1bc88842": {
    "message": "背景"
  },
  "backslash_b2d5442d": {
    "message": "反斜线"
  },
  "bar_ec63ed6": {
    "message": "横线"
  },
  "basic_554cdc0a": {
    "message": "基本"
  },
  "because_501841b": {
    "message": "因为"
  },
  "below_81d4dceb": {
    "message": "下方"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "大圆圈"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "二项式系数"
  },
  "black_4cb01371": {
    "message": "黑色"
  },
  "blue_daf8fea9": {
    "message": "蓝色"
  },
  "bold_applied_42d547b7": {
    "message": "已应用粗体"
  },
  "bold_removed_da474a5c": {
    "message": "已移除粗体"
  },
  "border_5b08b06d": {
    "message": "边框"
  },
  "bottom_15a2a9be": {
    "message": "底部"
  },
  "bottom_third_5f5fec1d": {
    "message": "倒数第三"
  },
  "bowtie_5f9629e4": {
    "message": "领结"
  },
  "brick_f2656265": {
    "message": "砖块"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "取消"
  },
  "cap_product_3a5265a6": {
    "message": "卡积"
  },
  "caption_manager_aae0906f": {
    "message": "字幕管理器"
  },
  "center_align_e68d9997": {
    "message": "居中对齐"
  },
  "centered_dot_64d5e378": {
    "message": "居中点"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "居中横点"
  },
  "change_alt_text_92654906": {
    "message": "更改替换文本"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "更改段落的标题标签"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "仅更改此标题级别"
  },
  "change_text_color_1aecb912": {
    "message": "更改文本颜色"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "保存此页面后，更改将生效。"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "您做出的变更可能无法保存。"
  },
  "characters_9d897d1c": {
    "message": "字符"
  },
  "characters_no_spaces_485e5367": {
    "message": "字符（无空格）"
  },
  "check_accessibility_3c78211c": {
    "message": "检查辅助功能"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "正在检查辅助功能问题"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "选择标题文件"
  },
  "choose_usage_rights_33683854": {
    "message": "选择使用权限..."
  },
  "circle_484abe63": {
    "message": "圆圈"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "圆形无序列表"
  },
  "clear_2084585f": {
    "message": "清除"
  },
  "clear_image_3213fe62": {
    "message": "清除图片"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "单击或按住 shift 并单击 html 编辑器。"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "单击以嵌入{ imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "单击以隐藏预览"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "单击以插入指向编辑器的链接。"
  },
  "click_to_show_preview_faa27051": {
    "message": "单击以显示预览"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "关闭菜单或对话框。并带您返回至编辑器区域"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "关闭辅助功能检查器"
  },
  "close_d634289d": {
    "message": "关闭"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "关闭快捷键模态弹框"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "关闭字幕的文件必须小于 { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "关闭了字幕/说明"
  },
  "clubs_suit_c1ffedff": {
    "message": "梅花（花色）"
  },
  "collab_575ac7bc": {
    "message": "协作"
  },
  "collaborations_5c56c15f": {
    "message": "协作"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "折叠以隐藏 { types }"
  },
  "color_a363e1b0": {
    "message": "颜色"
  },
  "color_contrast_4c418add": {
    "message": "色彩对比度"
  },
  "color_contrast_ratio_687782f0": {
    "message": "色彩对比度"
  },
  "color_picker_6b359edf": {
    "message": "颜色选取器"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "颜色选取器（已选择 { colorName }）"
  },
  "color_popup_af39810f": {
    "message": "色彩弹窗"
  },
  "column_e1ae5c64": {
    "message": "列"
  },
  "column_group_1c062368": {
    "message": "列组"
  },
  "complex_numbers_a543d004": {
    "message": "复数"
  },
  "computer_1d7dfa6f": {
    "message": "计算机"
  },
  "congruent_5a244acd": {
    "message": "全等"
  },
  "contains_311f37b7": {
    "message": "包含"
  },
  "content_1440204b": {
    "message": "内容"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "编辑器中的内容将更改。按“取消”以保留原始内容。"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "内容仍在上传中，如果您继续，该内容将不会正确嵌入。"
  },
  "content_subtype_5ce35e88": {
    "message": "内容子类型"
  },
  "content_type_2cf90d95": {
    "message": "内容类型"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "继续前往 YouTube 内容"
  },
  "coproduct_e7838082": {
    "message": "余积"
  },
  "copyright_holder_66ee111": {
    "message": "版权持有者："
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "无法插入内容：Canvas 目前不支持“{ itemType }”项目。"
  },
  "count_40eced3b": {
    "message": "计数"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 个字}\n    one {1 个字}\n  other {# 个字}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {已上传 # 项}\n  other {已上传 # 项}\n}"
  },
  "course_documents_104d76e0": {
    "message": "课程文件"
  },
  "course_files_62deb8f8": {
    "message": "课程文件"
  },
  "course_files_a31f97fc": {
    "message": "课程文件"
  },
  "course_images_f8511d04": {
    "message": "课程图像"
  },
  "course_link_b369426": {
    "message": "课程链接"
  },
  "course_links_b56959b9": {
    "message": "课程链接"
  },
  "course_media_ec759ad": {
    "message": "课程媒体"
  },
  "course_navigation_dd035109": {
    "message": "课程导航"
  },
  "create_icon_110d6463": {
    "message": "创建图标"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "创建图标编辑器图标"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons 许可证："
  },
  "crop_image_41bf940c": {
    "message": "裁剪图片"
  },
  "crop_image_807ebb08": {
    "message": "裁剪图像"
  },
  "cup_product_14174434": {
    "message": "上积"
  },
  "current_image_f16c249c": {
    "message": "当前图像"
  },
  "current_link_945a47ee": {
    "message": "当前链接"
  },
  "current_volume_level_c55ab825": {
    "message": "当前音量"
  },
  "custom_6979cd81": {
    "message": "自定义"
  },
  "cyan_c1d5f68a": {
    "message": "青色"
  },
  "dagger_57e0f4e5": {
    "message": "剑号"
  },
  "date_added_ed5ad465": {
    "message": "按添加日期排序"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "装饰性图标"
  },
  "decorative_image_fde98579": {
    "message": "装饰图片"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "装饰{ TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "减少缩进"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "减小富内容区域"
  },
  "deep_purple_bb3e2907": {
    "message": "深紫色"
  },
  "default_9db103d": {
    "message": "默认"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "默认项目符号无序列表"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "默认数字有序列表"
  },
  "definite_integral_fe7ffed1": {
    "message": "定积分"
  },
  "degree_symbol_4a823d5f": {
    "message": "度数符号"
  },
  "delimiters_4db4840d": {
    "message": "分隔符"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "（描述图标）"
  },
  "describe_the_type_ff448da5": {
    "message": "（描述{ TYPE }）"
  },
  "description_436c48d7": {
    "message": "说明"
  },
  "details_98a31b68": {
    "message": "详情"
  },
  "diagonal_dots_7d71b57e": {
    "message": "斜点"
  },
  "diamond_b8dfe7ae": {
    "message": "菱形"
  },
  "diamonds_suit_526abaaf": {
    "message": "方块（花色）"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "维度类型"
  },
  "directionality_26ae9e08": {
    "message": "方向"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "直接编辑 LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "禁用预览"
  },
  "discussion_6719c51d": {
    "message": "讨论"
  },
  "discussions_a5f96392": {
    "message": "讨论"
  },
  "discussions_index_6c36ced": {
    "message": "讨论索引"
  },
  "disjoint_union_e74351a8": {
    "message": "不交并"
  },
  "display_options_315aba85": {
    "message": "显示选项"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "显示文本链接（在新标签页中打开）"
  },
  "div_applied_49ad83fc": {
    "message": "已应用分区"
  },
  "div_removed_d13f8e17": {
    "message": "已移除分区"
  },
  "division_sign_72190870": {
    "message": "除号"
  },
  "document_678cd7bf": {
    "message": "文档"
  },
  "documents_81393201": {
    "message": "文档"
  },
  "done_54e3d4b6": {
    "message": "完成"
  },
  "double_dagger_faf78681": {
    "message": "双剑号"
  },
  "down_5831a426": {
    "message": "下"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "左下斜箭头"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "右下斜箭头"
  },
  "download_filename_2baae924": {
    "message": "下载 { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "向下箭头"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "倒三角"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "把文件拖动到此处"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "拖放或点击以浏览计算机"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "拖动手柄。使用上下箭头调整大小"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "到期：多个日期"
  },
  "due_when_7eed10c6": {
    "message": "到期：{ when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "编辑此图标实例的替换文本"
  },
  "edit_c5fbea07": {
    "message": "编辑"
  },
  "edit_course_link_5a5c3c59": {
    "message": "编辑课程链接"
  },
  "edit_equation_f5279959": {
    "message": "编辑等式"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "编辑现有图标制作者图标"
  },
  "edit_icon_2c6b0e91": {
    "message": "编辑图标"
  },
  "edit_link_7f53bebb": {
    "message": "编辑链接"
  },
  "editor_status_bar_653f44ee": {
    "message": "编辑器状态栏"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "以{ start }开始的元素"
  },
  "embed_828fac4a": {
    "message": "嵌入"
  },
  "embed_code_314f1bd5": {
    "message": "嵌入代码"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "从外部工具嵌入内容"
  },
  "embed_image_1080badc": {
    "message": "嵌入图片"
  },
  "embed_video_a97a64af": {
    "message": "嵌入视频"
  },
  "embedded_content_aaeb4d3d": {
    "message": "嵌入内容"
  },
  "empty_set_91a92df4": {
    "message": "空集"
  },
  "encircled_dot_8f5e51c": {
    "message": "带圆圈点"
  },
  "encircled_minus_72745096": {
    "message": "带圆圈负号"
  },
  "encircled_plus_36d8d104": {
    "message": "带圆圈正号"
  },
  "encircled_times_5700096d": {
    "message": "带圆圈次数"
  },
  "engineering_icon_f8f3cf43": {
    "message": "工程设计图标"
  },
  "english_icon_25bfe845": {
    "message": "英语图标"
  },
  "enter_a_media_title_81b490ec": {
    "message": "输入媒体标题"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "输入至少 3 个字符以进行搜索"
  },
  "enter_replacement_text_17631bbc": {
    "message": "输入替换文本"
  },
  "enter_search_text_26cb4459": {
    "message": "输入搜索文本"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon（变体）"
  },
  "equals_sign_c51bdc58": {
    "message": "等号"
  },
  "equation_1c5ac93c": {
    "message": "等式"
  },
  "equation_editor_39fbc3f1": {
    "message": "方程式编辑器"
  },
  "equilibrium_6ff3040b": {
    "message": "平衡点"
  },
  "equivalence_class_7b0f11c0": {
    "message": "等价类"
  },
  "equivalent_identity_654b3ce5": {
    "message": "等效标识"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "存在"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "退出全屏"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "默认展开预览"
  },
  "expand_to_see_types_f5d29352": {
    "message": "展开以查看 { types }"
  },
  "external_link_d3f9e62a": {
    "message": "外部链接"
  },
  "external_tool_frame_70b32473": {
    "message": "外部工具框架"
  },
  "external_tools_6e77821": {
    "message": "外部工具"
  },
  "extra_large_b6cdf1ff": {
    "message": "超大"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "超大 ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "特小"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "课外图标"
  },
  "f_function_fe422d65": {
    "message": "F（函数）"
  },
  "fail_544e5dde": {
    "message": "失败"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "文件内容获取失败"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "无法从外部工具检索内容"
  },
  "file_name_8fd421ff": {
    "message": "文件名称"
  },
  "file_preview_21667a6e": {
    "message": "文件预览"
  },
  "file_preview_for_filename_ab314195": {
    "message": "{ fileName } 文件预览"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "超出文件存储大小限制"
  },
  "file_url_c12b64be": {
    "message": "文件URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename }文件图标"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename }图像预览"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename }文本预览"
  },
  "files_c300e900": {
    "message": "文件"
  },
  "files_index_af7c662b": {
    "message": "文件索引"
  },
  "find_8d605019": {
    "message": "查找"
  },
  "find_and_replace_6e345933": {
    "message": "查找并替换"
  },
  "finish_bc343002": {
    "message": "完成"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "置顶标题层次结构"
  },
  "flat_music_76d5a5c3": {
    "message": "降调（音乐）"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "焦点元素选项工具栏"
  },
  "folder_tree_fbab0726": {
    "message": "文件夹树"
  },
  "for_all_b919f972": {
    "message": "全部"
  },
  "format_4247a9c5": {
    "message": "格式"
  },
  "format_as_a_list_142210c3": {
    "message": "使用列表格式"
  },
  "formatting_5b143aa8": {
    "message": "格式化"
  },
  "forward_slash_3f90f35e": {
    "message": "斜杠"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "找到自动保存的内容"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "查找 { count, plural,\n     =0 {# 结果}\n    one {# 结果}\n  other {# 结果}\n}"
  },
  "fraction_41bac7af": {
    "message": "分数"
  },
  "fullscreen_873bf53f": {
    "message": "全屏"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "生成预览..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "当前不支持大于 { size } KB 的 GIF/PNG 格式图像。"
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "前往编辑器的菜单栏"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "前往编辑器的工具栏"
  },
  "grades_a61eba0a": {
    "message": "评分"
  },
  "graphics_text_bc9568bc": {
    "message": "图形文本"
  },
  "greater_than_e98af662": {
    "message": "大于"
  },
  "greater_than_or_equal_b911949a": {
    "message": "大于等于"
  },
  "greek_65c5b3f7": {
    "message": "希腊语"
  },
  "green_15af4778": {
    "message": "绿色"
  },
  "grey_a55dceff": {
    "message": "灰色"
  },
  "group_documents_8bfd6ae6": {
    "message": "组文档"
  },
  "group_files_4324f3df": {
    "message": "小组文件"
  },
  "group_files_82e5dcdb": {
    "message": "组文件"
  },
  "group_images_98e0ac17": {
    "message": "组图像"
  },
  "group_isomorphism_45b1458c": {
    "message": "群同构"
  },
  "group_link_63e626b3": {
    "message": "组链接"
  },
  "group_links_9493129e": {
    "message": "小组链接"
  },
  "group_media_2f3d128a": {
    "message": "组媒体"
  },
  "group_navigation_99f191a": {
    "message": "小组导航"
  },
  "h_bar_bb94deae": {
    "message": "H 斜杠"
  },
  "hat_ea321e35": {
    "message": "帽"
  },
  "header_column_f27433cb": {
    "message": "标题列"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "标题行和列"
  },
  "header_row_f33eb169": {
    "message": "标题行"
  },
  "heading_2_5b84eed2": {
    "message": "标题 2"
  },
  "heading_3_2c83de44": {
    "message": "标题 3"
  },
  "heading_4_b2e74be7": {
    "message": "标题 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "已应用标题 { h }"
  },
  "heading_h_removed_745f24a6": {
    "message": "已移除标题 { h }"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "不得跳过标题级别。"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "以{ start }开始的标题"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "标题不得超过 120 个字符。"
  },
  "health_icon_8d292eb5": {
    "message": "健康图标"
  },
  "hearts_suit_e50e04ca": {
    "message": "红桃（花色）"
  },
  "height_69b03e15": {
    "message": "高度"
  },
  "hexagon_d8468e0d": {
    "message": "六边形"
  },
  "hide_description_bfb5502e": {
    "message": "隐藏说明"
  },
  "hide_title_description_caf092ef": {
    "message": "隐藏{ title }说明"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "高亮显示一个元素以激活元素选项工具栏"
  },
  "home_351838cd": {
    "message": "首页"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "如何请求和编辑字幕？"
  },
  "html_code_editor_fd967a44": {
    "message": "HTML 代码编辑器"
  },
  "html_editor_fb2ab713": {
    "message": "HTML 编辑器"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "我已获得使用此文件的权限。"
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "我持有版权"
  },
  "icon_215a1dc6": {
    "message": "图标"
  },
  "icon_8168b2f8": {
    "message": "图标"
  },
  "icon_color_b86dd6d6": {
    "message": "图标颜色"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "图标编辑器图标"
  },
  "icon_options_7e32746e": {
    "message": "图标选项"
  },
  "icon_options_tray_2b407977": {
    "message": "图标选项托盘"
  },
  "icon_preview_1782a1d9": {
    "message": "图标预览"
  },
  "icon_shape_30b61e7": {
    "message": "图标形状"
  },
  "icon_size_9353edea": {
    "message": "图标大小"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "如果不填，链接文本将显示为课程链接名称"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "如需使用权限，则在“文件”页面中启用文件之前，不会发布文件。"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "如果您现在不选择使用权限，该文件在上传后不会被发布。"
  },
  "image_8ad06": {
    "message": "图片"
  },
  "image_c1c98202": {
    "message": "图像"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "不得使用图像文件名作为描述图像内容的替换属性。"
  },
  "image_options_5412d02c": {
    "message": "图像选项"
  },
  "image_options_tray_90a46006": {
    "message": "图像选项托盘"
  },
  "image_to_crop_3a34487d": {
    "message": "剪裁图像"
  },
  "image_with_filename_file_aacd7180": {
    "message": "文件名为{ file }的图像"
  },
  "images_7ce26570": {
    "message": "图像"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "图像应包括一个描述图像内容的替换属性。"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "虚部（复数）"
  },
  "in_element_of_19ca2f33": {
    "message": "包含（元素）"
  },
  "increase_indent_6af90f7c": {
    "message": "增加缩进"
  },
  "increase_rich_content_area_340b775": {
    "message": "增大富内容区域"
  },
  "indefinite_integral_6623307e": {
    "message": "不定积分"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index }，共{ max }"
  },
  "indigo_2035fc55": {
    "message": "靛蓝色"
  },
  "inference_fed5c960": {
    "message": "推断"
  },
  "infinity_7a10f206": {
    "message": "无穷"
  },
  "input_field_for_alpha_678265fd": {
    "message": "α 输入字段"
  },
  "input_field_for_blue_561e020a": {
    "message": "蓝色输入字段"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "绿色输入字段"
  },
  "input_field_for_red_86a84615": {
    "message": "红色输入字段"
  },
  "insert_593145ef": {
    "message": "插入"
  },
  "insert_link_6dc23cae": {
    "message": "插入链接"
  },
  "insert_math_equation_57c6e767": {
    "message": "插入数学公式"
  },
  "integers_336344e1": {
    "message": "整数"
  },
  "intersection_cd4590e4": {
    "message": "相交"
  },
  "invalid_description_991e23bb": {
    "message": "无效的描述"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "无效的输入。"
  },
  "invalid_file_c11ba11": {
    "message": "无效的文件"
  },
  "invalid_file_type_881cc9b2": {
    "message": "无效的文件类型"
  },
  "invalid_url_cbde79f": {
    "message": "URL 无效"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "问题{ num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "已应用斜体"
  },
  "italic_removed_17cbab6f": {
    "message": "已移除斜体"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa（变体）"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "键盘捷径"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "键盘使用 Tab 键导航至链接。转至相同目的地的两个相邻链接可以对键盘用户造成混淆。"
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "语言艺术图标"
  },
  "languages_icon_9d20539": {
    "message": "语言图标"
  },
  "large_9c5e80e7": {
    "message": "大"
  },
  "large_text_e7ba08cd": {
    "message": "大文本"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "大 ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "学习"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "详细了解相邻链接"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "详细了解色彩对比度"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "详细了解组织页面标题"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "详细了解适当的页面标题结构"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "详细了解表标题"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "详细了解为使用图片替换文本"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "详细了解将标题与表格一起使用"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "详细了解使用文件名作为替换文本"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "详细了解使用列表"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "详细了解将范围属性与表格一起使用"
  },
  "leave_as_is_4facfe55": {
    "message": "保持原状"
  },
  "left_3ea9d375": {
    "message": "左侧"
  },
  "left_align_43d95491": {
    "message": "左对齐"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "左角括弧"
  },
  "left_arrow_4fde1a64": {
    "message": "左箭头"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "左转弯箭头"
  },
  "left_ceiling_ee9dd88a": {
    "message": "左向上取整符号"
  },
  "left_curly_brace_1726fb4": {
    "message": "左大括号"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "左下鱼叉箭头"
  },
  "left_floor_29ac2274": {
    "message": "左向下取整符号"
  },
  "left_to_right_e9b4fd06": {
    "message": "从左至右"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "左上鱼叉箭头"
  },
  "leftward_arrow_1e4765de": {
    "message": "左箭头"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "左指三角形"
  },
  "less_than_a26c0641": {
    "message": "小于"
  },
  "less_than_or_equal_be5216cb": {
    "message": "小于等于"
  },
  "library_icon_ae1e54cf": {
    "message": "图书馆图标"
  },
  "light_blue_5374f600": {
    "message": "浅蓝色"
  },
  "link_7262adec": {
    "message": "链接"
  },
  "link_options_a16b758b": {
    "message": "链接选项"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "链接类型：{ linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "具有以{ start }开始的文本的链接"
  },
  "links_14b70841": {
    "message": "链接"
  },
  "links_to_an_external_site_de74145d": {
    "message": "链接到外部网站。"
  },
  "lists_cd1336fc": {
    "message": "列表"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "列表应使用列表格式。"
  },
  "load_more_35d33c7": {
    "message": "加载更多"
  },
  "loading_25990131": {
    "message": "加载中……"
  },
  "loading_bde52856": {
    "message": "正在加载"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "加载关闭的字幕/副标题失败。"
  },
  "loading_external_tool_d839042c": {
    "message": "正在加载外部工具"
  },
  "loading_failed_b3524381": {
    "message": "加载失败……"
  },
  "loading_failed_e6a9d8ef": {
    "message": "加载失败。"
  },
  "loading_folders_d8b5869e": {
    "message": "正在加载文件夹"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "正在加载{ fileName }的占位符"
  },
  "loading_please_wait_d276220a": {
    "message": "正在加载，请稍候"
  },
  "loading_preview_9f077aa1": {
    "message": "加载预览"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "锁定 1 倍速度"
  },
  "locked_762f138b": {
    "message": "已锁定"
  },
  "logical_equivalence_76fca396": {
    "message": "逻辑等价"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "逻辑等价（短）"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "逻辑等价（短厚）"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "逻辑等价（厚）"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "下横点"
  },
  "magenta_4a65993c": {
    "message": "品红色"
  },
  "maps_to_e5ef7382": {
    "message": "映射到"
  },
  "math_icon_ad4e9d03": {
    "message": "数学图标"
  },
  "media_af190855": {
    "message": "媒体"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "媒体文件正在处理中。请稍后再试。"
  },
  "media_options_saved_560c4ec8": {
    "message": "媒体选项已保存。"
  },
  "media_title_2112243b": {
    "message": "媒体标题"
  },
  "medium_5a8e9ead": {
    "message": "中等"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "中 ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "合并链接"
  },
  "mic_a7f3d311": {
    "message": "麦克风"
  },
  "microphone_disabled_15c83130": {
    "message": "麦克风已禁用"
  },
  "middle_27dc1d5": {
    "message": "中间"
  },
  "minimize_file_preview_da911944": {
    "message": "最小化文件预览"
  },
  "minimize_video_20aa554b": {
    "message": "最小化视频"
  },
  "minus_fd961e2e": {
    "message": "减号"
  },
  "minus_plus_3461f637": {
    "message": "减号/加号"
  },
  "misc_3b692ea7": {
    "message": "其他"
  },
  "miscellaneous_e9818229": {
    "message": "其他"
  },
  "module_90d9fd32": {
    "message": "单元"
  },
  "modules_c4325335": {
    "message": "单元"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "正在移动图片以剪裁 { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "彩色图像"
  },
  "multiplication_sign_15f95c22": {
    "message": "乘号"
  },
  "music_icon_4db5c972": {
    "message": "音乐图标"
  },
  "my_files_2f621040": {
    "message": "我的文件"
  },
  "n_th_root_9991a6e4": {
    "message": "N 次方根"
  },
  "nabla_1e216d25": {
    "message": "微分算符"
  },
  "name_1aed4a1b": {
    "message": "名称"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "还原记号（音乐）"
  },
  "natural_numbers_3da07060": {
    "message": "自然数"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "导航菜单或工具栏"
  },
  "navigation_ee9af92d": {
    "message": "导航"
  },
  "nested_greater_than_d852e60d": {
    "message": "嵌套大于"
  },
  "nested_less_than_27d17e58": {
    "message": "嵌套小于"
  },
  "new_quiz_34aacba6": {
    "message": "新测验"
  },
  "next_40e12421": {
    "message": "下一步"
  },
  "next_findtext_9d69f0fe": {
    "message": "下一步{ findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "没有发现辅助功能问题。"
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "尚未创建公告。"
  },
  "no_announcements_found_20185afc": {
    "message": "未找到公告。"
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "尚未创建作业。"
  },
  "no_assignments_found_79e46d7f": {
    "message": "未找到作业。"
  },
  "no_changes_to_save_d29f6e91": {
    "message": "没有更改要保存。"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "尚未创建讨论。"
  },
  "no_discussions_found_9284063b": {
    "message": "未找到讨论。"
  },
  "no_e16d9132": {
    "message": "否"
  },
  "no_file_chosen_9a880793": {
    "message": "没有选择文件"
  },
  "no_headers_9bc7dc7f": {
    "message": "无标题"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "尚未创建单元。"
  },
  "no_modules_found_2df43a40": {
    "message": "未找到单元。"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "尚未创建页面。"
  },
  "no_pages_found_6799350": {
    "message": "未找到页面。"
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "没有预览可用于此文件。"
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "尚未创建测验。"
  },
  "no_quizzes_found_c80c537a": {
    "message": "未找到测验。"
  },
  "no_results_940393cf": {
    "message": "无结果。"
  },
  "no_results_found_58717065": {
    "message": "未发现结果"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "未找到{ filterTerm }的结果"
  },
  "no_video_1ed00b26": {
    "message": "无视频"
  },
  "none_3b5e34d2": {
    "message": "无"
  },
  "none_selected_b93d56d2": {
    "message": "未选中任何项"
  },
  "normal_text_7b03da48": {
    "message": "常规文本"
  },
  "not_equal_6e2980e6": {
    "message": "不相等"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "不包含（不是元素）"
  },
  "not_negation_1418ebb8": {
    "message": "非（否定）"
  },
  "not_subset_dc2b5e84": {
    "message": "非子集"
  },
  "not_subset_strict_23d282bf": {
    "message": "非子集（严格）"
  },
  "not_superset_5556b913": {
    "message": "非超集"
  },
  "not_superset_strict_24e06f36": {
    "message": "非超集（严格）"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "八边形"
  },
  "olive_6a3e4d6b": {
    "message": "橄榄"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "必须添加以下其中一个样式以保存图标：图标颜色、轮廓大小、图标文本或图像"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "一个或多个文件未能粘贴。请尝试上传或拖放文件。"
  },
  "open_circle_e9bd069": {
    "message": "开圆"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "打开此键盘快捷方式对话框"
  },
  "open_title_application_fd624fc5": {
    "message": "打开{ title }应用程序"
  },
  "operators_a2ef9a93": {
    "message": "运算符"
  },
  "options_3ab0ea65": {
    "message": "选项"
  },
  "or_9b70ccaa": {
    "message": "或"
  },
  "orange_81386a62": {
    "message": "橙色"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "有序列表和无序列表"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "其他编辑器快捷方式可见于"
  },
  "outline_color_3ef2cea7": {
    "message": "轮廓颜色"
  },
  "outline_size_a6059a21": {
    "message": "轮廓大小"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p }不是有效的协议。"
  },
  "page_50c4823d": {
    "message": "页面"
  },
  "pages_e5414c2c": {
    "message": "页面"
  },
  "paragraph_5e5ad8eb": {
    "message": "段落"
  },
  "paragraph_applied_959b3fe5": {
    "message": "已应用段落"
  },
  "paragraph_removed_d09320e": {
    "message": "已移除段落"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "以{ start }开始的段落"
  },
  "parallel_d55d6e38": {
    "message": "平行"
  },
  "partial_derivative_4a9159df": {
    "message": "偏（导数）"
  },
  "pass_1c19a2b3": {
    "message": "合格"
  },
  "paste_5963d1c1": {
    "message": "粘贴"
  },
  "pause_12af3bb4": {
    "message": "暂停"
  },
  "pentagon_17d82ea3": {
    "message": "五角形"
  },
  "people_b4ebb13c": {
    "message": "人员"
  },
  "percentage_34ab7c2c": {
    "message": "百分数"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "百分比必须是数字"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "百分数至少必须为 { percentage }%。"
  },
  "performing_arts_icon_f3497486": {
    "message": "表演艺术图标"
  },
  "perpendicular_7c48ede4": {
    "message": "正交"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi（变体）"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "体育图标"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi（变体）"
  },
  "pick_a_color_557abfb0": {
    "message": "选择颜色"
  },
  "pink_68ad45cb": {
    "message": "粉红色"
  },
  "pixels_52ece7d1": {
    "message": "像素"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "像素必须至少为 { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "播放"
  },
  "play_media_comment_35257210": {
    "message": "播放媒体评论。"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "播放{ name }的来自{ createdAt }的媒体评论。"
  },
  "player_layout_14e09a29": {
    "message": "播放器布局"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "请允许 Canvas 访问您的麦克风和网络摄像头。"
  },
  "please_choose_a_file_c2449cc": {
    "message": "请选择文件"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "请输入一个文件名"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "请输入来自支持的平台的有效的视频 URL。"
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "请选择支持类型的文件"
  },
  "plus_d43cd4ec": {
    "message": "加号"
  },
  "plus_minus_f8be2e83": {
    "message": "加号/减号"
  },
  "posted_when_a578f5ab": {
    "message": "发布日期：{ when }"
  },
  "power_set_4f26f316": {
    "message": "幂集"
  },
  "precedes_196b9aef": {
    "message": "先于"
  },
  "precedes_equal_20701e84": {
    "message": "先于等于"
  },
  "preformatted_d0670862": {
    "message": "预定义格式"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "上一个"
  },
  "preview_53003fd2": {
    "message": "预览"
  },
  "preview_a3f8f854": {
    "message": "预览"
  },
  "preview_in_overlay_ed772c46": {
    "message": "在图层中预览"
  },
  "preview_inline_9787330": {
    "message": "嵌入式预览"
  },
  "previous_bd2ac015": {
    "message": "上一个"
  },
  "previous_findtext_8dfbfd30": {
    "message": "上一步{ findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "之前选择的颜色"
  },
  "prime_917ea60e": {
    "message": "质"
  },
  "prime_numbers_13464f61": {
    "message": "质数"
  },
  "product_39cf144f": {
    "message": "乘积"
  },
  "proportional_f02800cc": {
    "message": "比例项"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "协议必须是 ftp、http、https、mailto、skype、tel 或可以忽略"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "已发布"
  },
  "published_when_302d8e23": {
    "message": "已发布：{ when }"
  },
  "pumpkin_904428d5": {
    "message": "南瓜"
  },
  "purple_7678a9fc": {
    "message": "紫色"
  },
  "quaternions_877024e0": {
    "message": "四元数"
  },
  "quiz_e0dcce8f": {
    "message": "测验"
  },
  "quizzes_7e598f57": {
    "message": "测验"
  },
  "rational_numbers_80ddaa4a": {
    "message": "有理数"
  },
  "real_numbers_7c99df94": {
    "message": "实数"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "实部（复数）"
  },
  "record_7c9448b": {
    "message": "记录"
  },
  "record_upload_media_5fdce166": {
    "message": "记录/上传媒体"
  },
  "recording_98da6bda": {
    "message": "录制"
  },
  "red_8258edf3": {
    "message": "红色"
  },
  "relationships_6602af70": {
    "message": "关系"
  },
  "religion_icon_246e0be1": {
    "message": "宗教图标"
  },
  "remove_f47dc62a": {
    "message": "移除"
  },
  "remove_filename_3ea029f6": {
    "message": "移除 { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "删除标题样式"
  },
  "remove_link_d1f2f4d0": {
    "message": "删除链接"
  },
  "replace_all_d3d68b3": {
    "message": "全部替换"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "将所有{ findText }全部替换为{ replaceText }"
  },
  "replace_e61834a7": {
    "message": "替换"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "将{ findText }替换为{ replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "替换为"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "将{ alertFindText }替换为{ alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "将所有{ alertFindText }全部替换为{ alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "重置"
  },
  "resize_ec83d538": {
    "message": "调整大小"
  },
  "restore_auto_save_deccd84b": {
    "message": "是否恢复自动保存？"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "结果 { index }/{ max }。"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "反十字转门（不产生）"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho（变体）"
  },
  "rich_content_editor_2708ef21": {
    "message": "富内容编辑器"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "富文本区域。按{ OSKey }+F8设置富内容编辑器快捷方式。"
  },
  "right_71ffdc4d": {
    "message": "右侧"
  },
  "right_align_39e7a32a": {
    "message": "右对齐"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "右角括弧"
  },
  "right_arrow_35e0eddf": {
    "message": "右箭头"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "右转弯箭头"
  },
  "right_ceiling_839dc744": {
    "message": "右向上取整符号"
  },
  "right_curly_brace_5159d5cd": {
    "message": "右大括号"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "右下鱼叉箭头"
  },
  "right_floor_5392d5cf": {
    "message": "右向下取整符号"
  },
  "right_to_left_9cfb092a": {
    "message": "从右至左"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "右上鱼叉箭头"
  },
  "rightward_arrow_32932107": {
    "message": "右箭头"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "右指三角形"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "-90 度旋转图像"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "90 度旋转图像"
  },
  "rotation_9699c538": {
    "message": "旋转"
  },
  "row_fc0944a7": {
    "message": "行"
  },
  "row_group_979f5528": {
    "message": "行组"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "很抱歉，无法通过键盘访问精美 HTML 编辑器。在此处访问原始 HTML 编辑器"
  },
  "save_11a80ec3": {
    "message": "保存"
  },
  "save_copy_ca63944e": {
    "message": "保存副本"
  },
  "save_media_cb9e786e": {
    "message": "保存媒体"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "保存的图标编辑器图标"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "如果没有替换文本，且文件名通常是不描述上下文或意义的无意义的数字和字母字符串，则屏幕读取器无法确定图像显示的内容。"
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "如果没有描述图像内容和意义的替换文本，则屏幕读取器无法确定图像显示的内容。替换文本应简单明了。"
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "如果没有描述图像内容和意义的替换文本，则屏幕读取器无法确定图像显示的内容。"
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "屏幕读取器无法解读不具有正确结构的表格。表格标题提供说明和内容范围。"
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "屏幕读取器无法解读不具有正确结构的表格。表格说明描述表格的上下文和对表格的一般理解。"
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "屏幕读取器无法解读不具有正确结构的表格。表格标题提供说明和内容概述。"
  },
  "script_l_42a7b254": {
    "message": "花体 L"
  },
  "search_280d00bd": {
    "message": "搜索"
  },
  "select_audio_source_21043cd5": {
    "message": "选择音频来源"
  },
  "select_crop_shape_d441feeb": {
    "message": "选择裁剪形状"
  },
  "select_language_7c93a900": {
    "message": "选择语言"
  },
  "select_video_source_1b5c9dbe": {
    "message": "选择视频来源"
  },
  "selected_274ce24f": {
    "message": "选定的"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "已选择 { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "选择"
  },
  "set_header_scope_8c548f40": {
    "message": "设置标题范围"
  },
  "set_minus_b46e9b88": {
    "message": "设置负"
  },
  "set_table_header_cfab13a0": {
    "message": "设置表格标题"
  },
  "sharp_music_ab956814": {
    "message": "升调（音乐）"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+箭头键"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "按 Shift-O 打开精美 HTML 编辑器。"
  },
  "shortcut_911d6255": {
    "message": "快捷方式"
  },
  "show_image_options_1e2ecc6b": {
    "message": "显示图像选项"
  },
  "show_link_options_545338fd": {
    "message": "显示链接选项"
  },
  "show_rolling_transcript_c1481744": {
    "message": "显示滚动字幕"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "显示滚动字幕"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "视力好的用户快速浏览网页，查找大号字体或粗体标题。屏幕读取器用户依赖于标题了解上下文。标题应使用正确的结构。"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "视力好的用户快速浏览网页，查找大号字体或粗体标题。屏幕读取器用户依赖于标题了解上下文。标题应在正确的结构内保持简洁。"
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma（变体）"
  },
  "single_color_image_4e5d4dbc": {
    "message": "单色图像"
  },
  "single_color_image_color_95fa9a87": {
    "message": "单色图像颜色"
  },
  "size_b30e1077": {
    "message": "大小"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "字幕文件的大小必须大于允许的文件大小最大值 { max } kb。"
  },
  "small_b070434a": {
    "message": "小"
  },
  "small_width_x_height_px_359acd38": {
    "message": "小 ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "实心圆"
  },
  "something_went_wrong_89195131": {
    "message": "出了些问题。"
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "访问您的网络摄像头时出现问题。"
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "出错了，我不知道该给您看些什么。"
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "出了些问题。检查您的网络连接，重新加载页面并重试。"
  },
  "something_went_wrong_d238c551": {
    "message": "出了些问题"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "共享屏幕时遇到问题。"
  },
  "sort_by_e75f9e3e": {
    "message": "排序"
  },
  "spades_suit_b37020c2": {
    "message": "黑桃（花色）"
  },
  "square_511eb3b3": {
    "message": "方形"
  },
  "square_cap_9ec88646": {
    "message": "方头"
  },
  "square_cup_b0665113": {
    "message": "方杯"
  },
  "square_root_e8bcbc60": {
    "message": "平方根"
  },
  "square_root_symbol_d0898a53": {
    "message": "平方根符号"
  },
  "square_subset_17be67cb": {
    "message": "平方子集"
  },
  "square_subset_strict_7044e84f": {
    "message": "平方子集（严格）"
  },
  "square_superset_3be8dae1": {
    "message": "平方超集"
  },
  "square_superset_strict_fa4262e4": {
    "message": "平方超集（严格）"
  },
  "square_unordered_list_b15ce93b": {
    "message": "方形无序列表"
  },
  "star_8d156e09": {
    "message": "星形标记"
  },
  "start_over_f7552aa9": {
    "message": "重新开始"
  },
  "start_recording_9a65141a": {
    "message": "开始录制"
  },
  "steel_blue_14296f08": {
    "message": "钢青色"
  },
  "studio_media_options_ee504361": {
    "message": "Studio 媒体选项"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio 媒体选项任务栏"
  },
  "styles_2aa721ef": {
    "message": "样式"
  },
  "submit_a3cc6859": {
    "message": "提交"
  },
  "submitting_b90fac62": {
    "message": "正在提交..."
  },
  "subscript_59744f96": {
    "message": "下标"
  },
  "subset_19c1a92f": {
    "message": "子集"
  },
  "subset_strict_8d8948d6": {
    "message": "子集（严格）"
  },
  "succeeds_9cc31be9": {
    "message": "后于"
  },
  "succeeds_equal_158e8c3a": {
    "message": "后于等于"
  },
  "sum_b0842d31": {
    "message": "总和"
  },
  "superscript_8cb349a2": {
    "message": "上标"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "上标和下标"
  },
  "superset_c4db8a7a": {
    "message": "超集"
  },
  "superset_strict_c77dd6d2": {
    "message": "超集（严格）"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "支持的文件类型：SRT或WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "切换到优质 HTML 编辑器"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "切换到原始 HTML 编辑器"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "切换到 HTML 编辑器"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "切换到富文本编辑器"
  },
  "syllabus_f191f65b": {
    "message": "教学大纲"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "系统音频已启用"
  },
  "system_audio_disabled_c177bd13": {
    "message": "系统音频已禁用"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/箭头"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "以{ start }开始的表格标题"
  },
  "table_starting_with_start_e7232848": {
    "message": "以{ start }开始的表格"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "表格标题应确定范围。"
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "表格应包括描述表格内容的说明。"
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "表格应包括至少一个标题。"
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "青色"
  },
  "text_7f4593da": {
    "message": "文本"
  },
  "text_background_color_16e61c3f": {
    "message": "文字背景颜色"
  },
  "text_color_acf75eb6": {
    "message": "文本颜色"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "文字和背景之间的对比度不足，因此文字阅读困难，尤其是对于视力较弱的人员而言。"
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "文字大于 18 磅（或粗体 14 磅）时显示的对比度应至少为 3:1。"
  },
  "text_optional_384f94f7": {
    "message": "文本（可选）"
  },
  "text_position_8df8c162": {
    "message": "文字位置"
  },
  "text_size_887c2f6": {
    "message": "文字大小"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "文字小于 18 磅（或粗体 14 磅）时显示的对比度应至少为 4.5:1。"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "目前正在处理文档预览。请稍后再试。"
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "页面上的第一个标题应该是H2。"
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "富内容区域的高度减小。"
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "富内容区域的高度增大。"
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "材料在公开域中"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "材料已根据 Creative Commons 许可"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "材料有例外情况——例如，合理使用、引用权，或版权法规定的其他适用的情况"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "无法通过键盘访问精美 HTML 编辑器。按 Shift O 打开原始 HTML 编辑器。"
  },
  "therefore_d860e024": {
    "message": "因此"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta（变体）"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "厚向下箭头"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "厚左箭头"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "厚向左箭头"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "厚右箭头"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "厚向右箭头"
  },
  "thick_upward_arrow_acd20328": {
    "message": "厚向上箭头"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "无法在 Canvas 中显示此文档。"
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "无法在基本视图中呈现此公式。"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "该图像目前不可用"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "此视频可能展示 YouTube 广告。"
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "虽然您的视频在浏览器里会有正确标题，但我们无法在数据库里更新。"
  },
  "thumbnail_e0de666f": {
    "message": "缩略图"
  },
  "timebar_a4d18443": {
    "message": "进度条"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "标题不能为空"
  },
  "title_ee03d132": {
    "message": "标题"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "待发布：{ when }"
  },
  "to_do_when_2783d78f": {
    "message": "待办事项：{ when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "切换{ summary }组"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "切换工具提示"
  },
  "tools_2fcf772e": {
    "message": "工具"
  },
  "top_66e0adb6": {
    "message": "顶部"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "字幕面板宽度高于 720px。"
  },
  "tray_839df38a": {
    "message": "托盘"
  },
  "triangle_6072304e": {
    "message": "三角形"
  },
  "turnstile_yields_f9e76df1": {
    "message": "十字转门（产生）"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "键入 Control F9 以访问图像选项。{ text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "键入 Control F9 以访问链接选项。{ text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "键入 Control F9 以访问表格选项。{ text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "无法确定资源选择 url"
  },
  "underline_applied_ae01ec97": {
    "message": "已应用下划线"
  },
  "underline_removed_3693e17c": {
    "message": "已移除下划线"
  },
  "union_e6b57a53": {
    "message": "并集"
  },
  "unpublished_dfd8801": {
    "message": "取消发布"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "未保存的更改将丢失。"
  },
  "untitled_16aa4f2b": {
    "message": "无标题"
  },
  "untitled_efdc2d7d": {
    "message": "无标题"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "左上斜箭头"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "右上斜箭头"
  },
  "up_c553575d": {
    "message": "上"
  },
  "updated_link_a827e441": {
    "message": "更新的链接"
  },
  "upload_document_253f0478": {
    "message": "上传文档"
  },
  "upload_file_fd2361b8": {
    "message": "上传文件"
  },
  "upload_image_6120b609": {
    "message": "上传图像"
  },
  "upload_media_ce31135a": {
    "message": "上传媒体"
  },
  "upload_record_media_e4207d72": {
    "message": "上传/录制媒体"
  },
  "uploading_19e8a4e7": {
    "message": "正在上传"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "大写字母有序列表"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "大写 Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "大写 Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "大写 Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "大写 Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "大写 Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "大写 Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "大写 Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "大写罗马数字有序列表"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "大写 Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "大写 Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "大写 Upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "大写 Xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "上指和下指箭头"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "上指和下指箭头（厚）"
  },
  "upward_arrow_9992cb2d": {
    "message": "向上箭头"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "上指三角形"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "使用权限："
  },
  "usage_rights_required_5fe4dd68": {
    "message": "使用权限（必填）"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "使用方向键来导航各选项。"
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "使用箭头键选择形状。"
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "使用箭头键选择大小。"
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "使用箭头键选择文字位置。"
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "使用箭头键选择文字大小。"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "使用箭头键选择轮廓大小。"
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "屏幕朗读器用来描述{ TYPE }的内容"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "屏幕阅读器用它来描述图像内容"
  },
  "user_documents_c206e61f": {
    "message": "用户文档"
  },
  "user_files_78e21703": {
    "message": "用户文档"
  },
  "user_images_b6490852": {
    "message": "用户图像"
  },
  "user_media_14fbf656": {
    "message": "用户媒体"
  },
  "vector_notation_cf6086ab": {
    "message": "矢量（符号）"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "竖线（集合生成器符号）"
  },
  "vertical_dots_bfb21f14": {
    "message": "竖点"
  },
  "video_options_24ef6e5d": {
    "message": "视频选项"
  },
  "video_options_tray_3b9809a5": {
    "message": "视频选项托盘"
  },
  "video_player_b371005": {
    "message": "视频播放器"
  },
  "video_player_for_9e7d373b": {
    "message": "的视频播放器 "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "{ title }的视频播放器"
  },
  "video_url_889d3263": {
    "message": "视频 URL"
  },
  "view_all_e13bf0a6": {
    "message": "查看全部"
  },
  "view_ba339f93": {
    "message": "查看"
  },
  "view_description_30446afc": {
    "message": "查看说明"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "查看键盘快捷键"
  },
  "view_title_description_67940918": {
    "message": "查看{ title }说明"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "查看字数和字符数"
  },
  "viewer_restrictions_e14274c9": {
    "message": "查看器限制"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "我们未发现正常工作的麦克风连接到设备。"
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "我们未发现正常工作的网络摄像头连接到设备。"
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "我们未发现正常工作的网络摄像头或麦克风连接到设备。"
  },
  "webcam_disabled_30c66986": {
    "message": "网络摄像头已禁用"
  },
  "webcam_fe91b20f": {
    "message": "网络摄像头"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "网页应仅具有一个H1，自动供页面标题使用。内容中的第一个标题应该是H2。"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "如果对使用列表格式显示的项目使用标记，但不指示列表关系，用户可能在浏览信息时会遇到困难。"
  },
  "white_87fa64fd": {
    "message": "白色"
  },
  "why_523b3d8c": {
    "message": "原因"
  },
  "width_492fec76": {
    "message": "宽度"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "宽度和高度必须为数字"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "维基主页"
  },
  "word_count_c77fe3a6": {
    "message": "字数统计"
  },
  "words_b448b7d5": {
    "message": "字"
  },
  "wreath_product_200b38ef": {
    "message": "圈积"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "是"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "您正在使用调色盘。请分别使用“W”、“A”、“S”和“D”在调色盘上向上、左、下或右浏览"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "您正在使用颜色滑块。请分别使用“A”和“D”在滑块上向左或向右浏览"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "您正在使用 α 滑块。请分别使用“A”和“D”在滑块上向左或向右浏览"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "“图标编辑器”托盘中有未保存的更改。是否要继续操作而不保存这些更改？"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "您可能需要调整其他标题以保持页面层次结构。"
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "无法上传空文件。"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "您的图像已被压缩以用于 Icon Maker。小于 { size } KB 的图像将不会被压缩。"
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "您的麦克风在浏览器设置中被拦截。"
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "您的网络摄像头和麦克风在浏览器设置中被拦截。"
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "您的网络摄像头在浏览器设置中被拦截。"
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "您的网络摄像头可能正在使用中。"
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube 嵌入 URL"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "缩放"
  },
  "zoom_in_image_bb97d4f": {
    "message": "放大图片"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "缩小图片"
  }
};
formatMessage.addLocale({
  'zh-Hans': locale
});